import { TRAFFIC_LIGHT_COLOURS as COLOURS, deliveryPerformanceLegend } from '@src/modules/performance/shared/constants';
import { useDeliveryPerformanceKPI } from '@src/modules/performance/context/map-api-hooks';
import { Text } from '@chakra-ui/react';
import Widget from './Widget';
import { CircleIndicator } from '../indicators';
import { mapValueToColourRange, roundKpiValue } from '../../shared/helpers';
import IndicatorLegend from '../IndicatorLegend';
import GroupedRegionMessage from '../GroupedRegionMessage';

export default function DeliveryPerformanceWidget() {
  const { data: deliveryPerformanceData, isLoading, isError } = useDeliveryPerformanceKPI();

  const title = 'Road Maintenance Delivery';
  const description = 'Budget variance (%)';
  const colour = mapValueToColourRange(deliveryPerformanceData?.varianceExclEmergency, 'deliveryPerformance');

  // If there is an error we want to hide the widget
  if (isError) return null;

  return (
    <Widget
      link="/performance/dashboard/delivery-performance"
      title={title}
      description={description}
      lockYear={deliveryPerformanceData?.lockYear}
      quarter={deliveryPerformanceData?.quarter}
      quarterFormat="ltp"
      isLoading={isLoading && !deliveryPerformanceData}
      moreInfoContent={(
        <>
          <Text fontSize="sm" mb={4}>
            Approved budget vs expenditure variance for all maintenance activities excluding emergency works, from the start of the NLTP period.
          </Text>
          <IndicatorLegend items={deliveryPerformanceLegend} />
          <GroupedRegionMessage
            rcaIds={[1014, 1016]}
            roadTypes={['shlr', 'sh']}
            messagePrefix="Combined results for"
            messageSuffix="for State Highways and All Roads"
          />
        </>
      )}
    >
      <CircleIndicator
        size={100}
        colour={COLOURS[colour]}
        value={deliveryPerformanceData?.varianceExclEmergency !== null && deliveryPerformanceData?.varianceExclEmergency !== undefined ? `${roundKpiValue(deliveryPerformanceData?.varianceExclEmergency, 5, 1)}%` : null}
        isLoading={isLoading}
        padding={0}
      />
    </Widget>
  );
}
